import React, { useMemo, useCallback, ChangeEventHandler } from 'react';
import { Moment } from 'moment';
import { isMomentValid } from '../utils';

export interface YearProps {
  className: string;
  year: number;
  moment: Moment;
  minMoment?: Moment;
  maxMoment?: Moment;
  onChange: (year: number) => void;
}

const range = [0, 3000];

function limitRange(year: number) {
  return Math.min(Math.max(year, range[0]), range[1]);
}

export default function Year({
  className,
  year,
  moment,
  minMoment,
  maxMoment,
  onChange
}: YearProps) {
  const years = useMemo(() => {
    const minYear = minMoment ? limitRange(minMoment.year()) : range[0];
    const maxYear = maxMoment ? limitRange(maxMoment.year()) : range[1];
    return Array.from({ length: maxYear - minYear + 1 }).map(
      (v, i) => i + minYear
    );
  }, [minMoment, maxMoment]);
  const change = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    event => onChange(+event.target.value),
    [onChange]
  );

  return (
    <select className={className} value={year} onChange={change}>
      {years.map((y, index) => (
        <option
          key={y}
          value={y}
          disabled={
            index === 0 || index === years.length - 1
              ? isMomentValid(
                  moment.clone().year(y),
                  minMoment,
                  maxMoment,
                  'month'
                ) !== 0
              : false
          }
        >
          {y}
        </option>
      ))}
    </select>
  );
}
